import { useEffect } from "react";
import { useLocation, useNavigate } from "react-router";

import { viewPathConstants } from "../../constants/global.constants";

// Stop the browser back button from leaving the stores page.
const BrowserHistoryGuard = () => {
  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    const handlePopstate = () => {
      if (
        window.history.state &&
        window.history.state.prevPath !== viewPathConstants.STORES
      ) {
        navigate(viewPathConstants.STORES);
      }
    };
    window.onpopstate = handlePopstate;

    if (location.pathname === viewPathConstants.STORES) {
      // Save the current route as the previous route in the history state
      window.history.replaceState({ prevPath: viewPathConstants.STORES }, null);
    } else {
      // Reset the onpopstate handler for other routes
      window.onpopstate = null;
    }
  }, [location.pathname, navigate]);

  return null;
};

export default BrowserHistoryGuard;
